'use strict';

const processInclude = require('BASE/util');

$(document).ready(function() {
  processInclude(require('./login/login'));
});
